import type { TFunction } from "i18next";

/** Human-readable labels for backend catalog `requires` permission codes. */
export function formatCatalogRequiresNote(
  requires: readonly string[],
  t: TFunction,
): string {
  const grants = requires.map((code) => permissionRequiresLabel(code, t)).join(", ");

  return t("accessRequests.dialog.requiresNote", { grants });
}

function permissionI18nSuffix(code: string): string {
  return code.replace(/\./g, "_");
}

export function permissionRequiresLabel(code: string, t: TFunction): string {
  const key = `accessRequests.requiredGrants.${permissionI18nSuffix(code)}`;
  const translated = t(key);
  if (translated !== key) {
    return translated;
  }
  return humanizePermissionCode(code);
}

function humanizePermissionCode(code: string): string {
  const [module, action] = code.split(".");
  const moduleLabel = (module ?? code).replace(/_/g, " ");
  if (!action) {
    return moduleLabel;
  }
  const actionLabel = action.replace(/_/g, " ");
  return `${moduleLabel} (${actionLabel})`;
}
